import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ListAltIcon from '@material-ui/icons/ListAlt';

import {
  PERMISSAO_TELA_MENSAL_LISTAR,
  PERMISSAO_TELA_ANUAL_LISTAR,
  PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR,
  PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR,
  PERMISSAO_TELA_INDICADORES_KPI_LISTAR,
  PERMISSAO_TELA_INVENTARIO_LISTAR,
  PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR,
  PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR,
  PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_CARTOES_LISTAR,
  PERMISSAO_TELA_FLUXO_CAIXA_LISTAR,
  PERMISSAO_TELA_SCORES_LISTAR,
  PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR,
  PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR,
  PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';
import StyledMenuItemLink from './StyledMenuItemLink';

const SubMenuRelatorio = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Relatórios"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_MENSAL_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_mensal_vendas"
        to="/relatorio_mensal_vendas"
        primaryText="Mensal"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_ANUAL_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_anual_vendas"
        to="/relatorio_anual_vendas"
        primaryText="Anual"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos"
        to="/relatorio_produtos"
        primaryText="Produtos"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_clientes"
        to="/relatorio_clientes"
        primaryText="Clientes"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_INDICADORES_KPI_LISTAR] && (
      <StyledMenuItemLink
        key="indicadores_kpi"
        to="/indicadores_kpi"
        primaryText="Indicadores kpi"
        leftIcon={<AttachMoneyIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_INVENTARIO_LISTAR] && (
      <StyledMenuItemLink
        key="inventario"
        to="/inventario"
        primaryText="Inventário"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_cadastro_clientes"
        to="/relatorio_cadastro_clientes"
        primaryText="Cadastro Clientes"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos_setores_inventario"
        to="/relatorio_produtos_setores_inventario"
        primaryText="Produtos de um local"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos_colaborador_inventario"
        to="/relatorio_produtos_colaborador_inventario"
        primaryText="Produtos colaborador"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_produtos_colaborador_fardamento"
        to="/relatorio_produtos_colaborador_fardamento"
        primaryText="Fardamentos Colaborador"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_CARTOES_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio_cartoes"
        to="/relatorio_cartoes"
        primaryText="Relatório Cartões"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_FLUXO_CAIXA_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio-fluxo-caixa"
        to="/relatorio-fluxo-caixa"
        primaryText="Relatório Fluxo Caixa"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_SCORES_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio-scores"
        to="/relatorio-scores"
        primaryText="Relatório Scores"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
    {permissoes[PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR] &&
      hasResource('vendas_excluidas')}
    {permissoes[PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR] &&
      hasResource('itens_vendas_excluidas')}
    {permissoes[PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR] && (
      <StyledMenuItemLink
        key="relatorio-compras-fiscais"
        to="/relatorio-compras-fiscais"
        primaryText="Relatório Compras Fiscais"
        leftIcon={<ListAltIcon className={classes.icon} />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
      />
    )}
  </SubMenu>
);

export default SubMenuRelatorio;
